import { useCallback } from "react";
import { usePaymentCoreStore } from "@/features/payment/store/payment-core-store.ts";
import type { PaymentStep } from "@/features/payment/store/payment-core-store.ts";

export const usePaymentCore = () => {
  const {
    isPaymentModalOpen,
    currentStep,
    successVariant,
    paymentProvider,
    sessionId,
    sessionUrl,
    error,
    isLoading,
    isRedirecting,
    openPaymentModal,
    closePaymentModal,
    openSubscriptionChangeModal,
    setCurrentStep,
    setSessionId,
    setSessionData,
    clearSessionData,
    setError,
    clearError,
    setLoading,
    setRedirecting,
    resetPayment,
  } = usePaymentCoreStore();

  // Start payment process
  const startPayment = useCallback(
    (
      provider: string,
      sessionId?: string,
      sessionUrl?: string,
      step?: PaymentStep
    ) => {
      openPaymentModal(provider, sessionId, sessionUrl, step);
    },
    [openPaymentModal]
  );

  // Complete payment process
  const completePayment = useCallback(() => {
    closePaymentModal();
    resetPayment();
  }, [closePaymentModal, resetPayment]);

  // Handle payment success
  const handleSuccess = useCallback(() => {
    // setCurrentStep("success"); // Zaten success step'inde olduğumuz için gerekli değil
    setLoading(false);
    setRedirecting(false);
  }, [setLoading, setRedirecting]);

  // Handle payment error
  const handleError = useCallback(
    (errorMessage: string) => {
      setError(errorMessage);
      setLoading(false);
      setRedirecting(false);
    },
    [setError, setLoading, setRedirecting]
  );

  // Handle payment cancel
  const handleCancel = useCallback(() => {
    setCurrentStep("cancel");
    setLoading(false);
    setRedirecting(false);
  }, [setCurrentStep, setLoading, setRedirecting]);

  return {
    // State
    isPaymentModalOpen,
    currentStep,
    successVariant,
    paymentProvider,
    sessionId,
    sessionUrl,
    error,
    isLoading,
    isRedirecting,

    // Actions
    startPayment,
    completePayment,
    closePaymentModal,
    openSubscriptionChangeModal,
    handleSuccess,
    handleError,
    handleCancel,
    setCurrentStep,
    setSessionId,
    setSessionData,
    clearSessionData,
    setError,
    clearError,
    setLoading,
    setRedirecting,
    resetPayment,
  };
};
